import React, { useState, useEffect } from "react";

export interface DialogProps {
  isOpened: boolean;
  title: string;
  message: string;
  cancelButtonText?: string;
  okButtonText?: string;
  onClose?: () => void;
  onOkButtonClick?: () => void;
}

export default function useDialog(
  props: DialogProps
): [DialogProps, () => void] {
  const [propsState, setPropsState] = useState(props);

  useEffect(() => {
    propsState.onClose = close;
  }, []);

  const open = () => {
    setPropsState(previousState => ({
      ...previousState,
      isOpened: true
    }));
  };

  const close = () => {
    setPropsState(previousState => ({
      ...previousState,
      isOpened: false
    }));
  };

  return [propsState, open];
}
